

































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
// eslint-disable-next-line no-unused-vars
import { ShoppingCartItemType, ShoppingCart } from "@/types";
import SharedMixin from "@/mixins/shared";

@Component({
  mixins: [SharedMixin]
})
export default class CatalogItemCard extends Vue {
  @Prop() id!: string;
  @Prop() img!: string;
  @Prop() code!: string;
  @Prop() color!: string;
  @Prop() name!: string;
  @Prop() urlCode!: string;
  @Prop() price!: number;

  disabled = false;

  get imgUrl() {
    return this.img === ""
      ? require("@/assets/img/course-preview-default.jpg")
      : this.img;
  }

  async addItemToCart(): Promise<void> {
    this.$store.commit("ecommerce/setShoppingCartStatus", false);

    // Add new item to database
    await this.$store.dispatch("ecommerce/addItemToCart", {
      id: this.id,
      name: this.name,
      type: ShoppingCartItemType.Course
    });

    this.$store.commit("ecommerce/setShoppingCartStatus", true);
  }

  @Watch("$store.state.ecommerce.shoppingCartStatus", { immediate: true })
  watchShoppingCartStatus(newVal: boolean) {
    this.disabled = !newVal;
  }
}
